// ─── Sorting ───────────────────────────────────────────────────────────────

export const FIELD_TO_SORT_KEY = {
  subject: 'subject',
  'author_details.first_name': 'author',
  case_name: 'case_name',
  is_new: 'status',
  last_reply: 'last_reply',
  attachment: 'attachment',
  aggregate_sentiment: 'sentiment',
};

// ─── Configuration ─────────────────────────────────────────────────────────

export const MESSAGE_PREVIEW_MAX_LENGTH = 100;

export const PAGINATION_CONFIG = {
  STORAGE_KEY: 'message_list_v2_column_widths',
  BREAKPOINT: '960px',
};

export const PAGINATION_PATHS = {
  LEADS: { module: 'leads', subModule: '', listName: 'message' },
  CASE: { module: 'case', subModule: '', listName: 'message' },
  MESSAGES: { module: 'messages', subModule: '', listName: 'self' },
  CLIENT_PORTAL: { module: 'client_portals', subModule: 'messages', listName: 'self' },
};

// ─── Text & Labels ─────────────────────────────────────────────────────────

export const LABELS = {
  CREATE_MESSAGE: 'Create Message',
  CREATE_IN_ALL_COMPANIONS: 'Create Message in All Companion Cases',
  COMPANION_DESCRIPTION: 'Send the same message to the primary contact in each companion case.',
  SECURE_MESSAGES_TITLE: 'Secure Messages',
  FILTERS_LABEL: 'Filters:',
};

export const FILTER_PLACEHOLDERS = {
  SEARCH: 'Search',
  BY_CASE_LEAD: 'By Case/Lead',
  BY_AUTHOR: 'By Author',
  BY_DATE: 'By Date',
  BY_MESSAGE_STATUS: 'By Message Status',
  BY_PARTICIPANTS: 'By Participants',
  BY_SENTIMENT: 'By Sentiment',
  NO_CASES_FOUND: 'No Cases/Leads Found',
};

export const TABLE_MESSAGES = {
  LOADING: 'Loading...',
  NO_DATA: 'No Data Found.',
  REPLIES_PLURAL: 'Replies',
  REPLY_SINGULAR: 'Reply',
};

export const TOOLTIPS = {
  NEW_MESSAGE: 'You have unread replies in the message thread',
  MARK_READ: 'Mark as Read',
  MARK_UNREAD: 'Mark as Unread',
  RESET_FILTER: 'Reset Filter',
  NEW_SIDEBAR_MESSAGE: 'You have unread messages in sidebar chat',
  NO_NEW_SIDEBAR_MESSAGE: 'No new unread messages in sidebar chat',
};
